import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-12 px-6"},[_c('h1',[_vm._v("Users")]),_c(VCard,{attrs:{"outlined":""}},[_c(VCardTitle,[_vm._v("Users")]),_c(VCardText)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }